import { render, staticRenderFns } from "./ResourcesRoute.vue?vue&type=template&id=7a72b16b&scoped=true&"
import script from "./ResourcesRoute.vue?vue&type=script&lang=js&"
export * from "./ResourcesRoute.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesRoute.vue?vue&type=style&index=0&id=7a72b16b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72b16b",
  null
  
)

export default component.exports